import { http } from '@/utils/request'

export interface communityQueryParams {
    topicTypeId?: string | number, //讨论分类
    title?: string,
    orderByColumn?: string, //排序字段
    isAsc?: string,
    pageNum?: number,
    pageSize?: number,
}

/**
 * CommunityTopicBo，社区话题业务对象 community_topic
 */
export interface CreateTopicParams {
    /** 话题ID（编辑时需要） */
    id?: string | number;
    /** 命中的敏感词 */
    auditKeywords?: string;
    /** 内容 */
    content?: string;
    /** 概述 */
    overview?: string;
    /** 标签（多个标签用逗号分隔） */
    tags?: string;
    /** 标题 */
    title?: string;
    /** 话题分类ID */
    topicTypeId?: string | number;
}

export interface CreateTopicCommentParams {
    /** 评论话题ID */
    topicId?: number | string;
    /** 内容 */
    content?: string;
}

// 社区相关 API
export const communityApi = {
    // 查询社区统计数据
    getTopicStatistics: () =>
        http.get(`/topic/statistics`),

    // 获取社区话题讨论类别
    getTopicTypes: (params: string) =>
        http.get(`/system/dict/data/type/${params}`),

    // 获取讨论列表
    getCommunities: (params: communityQueryParams) =>
        http.get('/topic/list', params),

    // 获取讨论详情
    getTopicDetail: (id: string | number) =>
        http.get(`/topic/${id}`),

    // 创建讨论主题
    createTopic: (params: CreateTopicParams) =>
        http.post('/topic', params),

    // 编辑讨论主题
    updateTopic: (params: CreateTopicParams) =>
        http.put('/topic', params),

    // 获取社区话题评论
    getTopicComment: (params: {topicId: number | string}) =>
        http.get('/topicComment/list', params),

    // 创建社区话题评论
    createTopicComment: (params: CreateTopicCommentParams) =>
        http.post('/topicComment', params),

    // 点赞社区话题评论
    likeTopicComment: (commentId: string | number) =>
        http.get(`/commentLike/like/${commentId}`),

    // 取消点赞社区话题评论
    cancelLikeTopicComment: (commentId: string | number) =>
        http.get(`/commentLike/unlike/${commentId}`),

    // 收藏社区话题
    collectTopic: (topicId: string | number) =>
        http.get(`/topicCollection/collect/${topicId}`),

    // 取消收藏社区话题
    cancelCollectTopic: (topicId: string | number) =>
        http.get(`/topicCollection/uncollect/${topicId}`),

    // 获取我的话题列表
    getMyTopics: (params?: { title?: string; topicTypeId?: string | number }) =>
        http.get('/topic/myList', params),

    // 删除话题
    deleteTopic: (topicId: string | number) =>
        http.delete(`/topic/${topicId}`),
}